(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["explore-all-concerns"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initExploreAllConcerns(section) {
    if (!section || section.dataset.eacInitialized === 'true') return;

    const content = section.querySelector('.explore-all-concerns__content');

    if (!content) return;

    const concerns = Array.from(
      content.querySelectorAll(':scope > .explore-concern')
    );

    if (!concerns.length) return;

    section.dataset.eacInitialized = 'true';

    /* -----------------------------------------
       Create tabs navigation
       ----------------------------------------- */

    const tabs = document.createElement('div');

    tabs.className = 'explore-all-concerns__tabs';

    tabs.setAttribute('role', 'tablist');

    const tabsInner = document.createElement('div');

    tabsInner.className = 'explore-all-concerns__tabs-inner';

    tabs.appendChild(tabsInner);

    content.insertBefore(tabs, content.firstChild);


    /* -----------------------------------------
       Create cloned tabs
       ----------------------------------------- */

    concerns.forEach((concern, index) => {
      const originalTab = concern.querySelector(
        '[data-concern-tab]'
      );

      const panel = concern.querySelector(
        '[data-concern-panel]'
      );

      if (!originalTab || !panel) return;


      /* Hide original tab visually.
         We do NOT remove it from the DOM. */

      originalTab.classList.add(
        'explore-concern__tab--source'
      );


      /* Create a safe clone containing only
         the tab UI. */

      const clonedTab = originalTab.cloneNode(true);

      clonedTab.classList.remove(
        'explore-concern__tab--source'
      );

      clonedTab.classList.add(
        'explore-all-concerns__tab'
      );

      clonedTab.removeAttribute('id');

      clonedTab.removeAttribute('aria-controls');

      clonedTab.setAttribute(
        'role',
        'tab'
      );

      clonedTab.setAttribute(
        'aria-selected',
        index === 0 ? 'true' : 'false'
      );

      clonedTab.dataset.concernIndex = index;


      tabsInner.appendChild(clonedTab);


      /* -----------------------------------------
         Initial state
         ----------------------------------------- */

      const isActive = index === 0;

      concern.classList.toggle(
        'is-active',
        isActive
      );

      panel.hidden = !isActive;

      clonedTab.classList.toggle(
        'is-active',
        isActive
      );


      /* -----------------------------------------
         Tab click
         ----------------------------------------- */

      clonedTab.addEventListener(
        'click',
        () => {

          concerns.forEach(
            (otherConcern, otherIndex) => {

              const otherPanel =
                otherConcern.querySelector(
                  '[data-concern-panel]'
                );

              const otherClonedTab =
                tabsInner.querySelector(
                  `[data-concern-index="${otherIndex}"]`
                );


              const active =
                otherIndex === index;


              otherConcern.classList.toggle(
                'is-active',
                active
              );


              if (otherPanel) {
                otherPanel.hidden = !active;
              }


              if (otherClonedTab) {
                otherClonedTab.classList.toggle(
                  'is-active',
                  active
                );

                otherClonedTab.setAttribute(
                  'aria-selected',
                  active ? 'true' : 'false'
                );
              }
            }
          );

        }
      );
    });
  }


  function initAllExploreSections(root = document) {

    root
      .querySelectorAll('.explore-all-concerns')
      .forEach((section) => {
        initExploreAllConcerns(section);
      });

  }


  /* Initial load */
  initAllExploreSections();


  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllExploreSections(event.target);
    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-bundles"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.__popularBundlesTabsInitialized) return;

  window.__popularBundlesTabsInitialized = true;

  document.addEventListener('click', (event) => {
    const filter = event.target.closest(
      '.popular-bundles [data-bundle-filter]'
    );

    if (!filter) return;

    const section = filter.closest('.popular-bundles');

    if (!section) return;

    event.preventDefault();

    const selectedTab = filter.getAttribute(
      'data-bundle-filter'
    );

    section
      .querySelectorAll('[data-bundle-filter]')
      .forEach((item) => {
        const isActive = item === filter;

        item.classList.toggle('is-active', isActive);
        item.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });

    section
      .querySelectorAll('[data-bundle-card]')
      .forEach((card) => {
        const cardTab = card.getAttribute('data-category');

        const shouldShow =
          selectedTab === 'all' ||
          cardTab === selectedTab;

        card.classList.toggle('is-hidden', !shouldShow);
      });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
